<template>
  <nav>
    <div class="nav-links">
      <router-link to="/home">Home</router-link> |
      <router-link to="/history">History</router-link> |
      <router-link to="/graph">Graph</router-link>
    </div>
    <router-link to="/profile" class="profile-link">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        id="Outline"
        viewBox="0 0 24 24"
        width="25"
        height="25"
        fill="white"
      >
        <path
          d="M12,12A6,6,0,1,0,6,6,6.006,6.006,0,0,0,12,12ZM12,2A4,4,0,1,1,8,6,4,4,0,0,1,12,2Z"
        />
        <path
          d="M12,14a9.01,9.01,0,0,0-9,9,1,1,0,0,0,2,0,7,7,0,0,1,14,0,1,1,0,0,0,2,0A9.01,9.01,0,0,0,12,14Z"
        />
      </svg>
    </router-link>
  </nav>
  <div class="container py-4">
    <router-view />
  </div>
</template>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}

.profile-link {
  position: absolute;
  right: 30px;
}

@media (max-width: 768px) {
  html,
  body {
    height: 100%;
  }

  #app {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .container > *:last-child {
    margin-bottom: 50px;
  }

  .container {
    flex: 1;
    overflow-y: auto;
  }

  nav {
    position: static;
    order: 2;
    flex-shrink: 0;
    padding: 12px 0;
    border-top: 1px solid #334155;
    justify-content: space-around;
  }

  .profile-link {
    position: static;
  }

  .nav-links {
    display: flex;
    gap: 16px;
  }
}
</style>

<script>
export default {
  data() {
    return {
      errorMessage: "",
      errorCaught: false,
    };
  },
  computed() {
    window.addEventListener("error", (event) => {
      this.errorMessage = event.message;
      this.errorCaught = true;
    });
    throw new Error("hello");
  },
};
</script>
